import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-eatl-business3',
  templateUrl: './eatl-business3.component.html',
  styleUrls: ['./eatl-business3.component.scss']
})
export class EatlBusiness3Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
